import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, Row, Col } from 'react-flexbox-grid';
import Paper from 'material-ui/Paper';
import Chip from 'material-ui/Chip';
import Divider from 'material-ui/Divider';
import {List, ListItem} from 'material-ui/List';
import KeyboardArrowRight from 'material-ui-icons/KeyboardArrowRight';
import './Education.css';
import Avatar from 'material-ui/Avatar';
import asulogo from './img/asu-logo.png';
import asulo from './img/asu_logo.png';
import pictlogo from './img/pict-logo.png';

class Education extends Component {
    render() {
        let leftPosition = this.props.browser.greaterThan.medium || this.props.responsiveDrawer.open ? 200 : 0;

        const style = {
            height: '30px',
            textAlign: 'center',
            backgroundColor: '#ffd740',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            margin: 0,
            marginLeft: leftPosition,
        };

        const listStyle = {
            marginTop: '5px',
            marginBottom: '5px',
            paddingTop: '2px',
            paddingBottom: '2px',
            marginLeft: '0px',
            paddingLeft: '40px',
            fontFamily: "Raleway, sans-serif",
            lineHeight: 1.3
        }

        const iconStyle= {
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: '-2px',
            marginBottom: '2px',
            paddingTop: '0px',
            paddingBottom: '0px',
            paddingLeft: '0px',
            marginLeft: '0px',
            display: 'flex',
            height: 25,
            width: 25
        }

        const logoStyle = {
            float: 'right',
            marginTop: 20,
            backgroundColor: '#efebe9',
            width: 100
        }

        return (
            <Grid className="Education" style={{ margin: 0, width: '100%', backgroundColor: '#efebe9' }}>
                <Row style={{ margin: 0 }}>
                    <Col xs style={{ padding: 0 }}>
                        <Paper style={style} zDepth={1}
                        />
                    </Col>
                </Row>
                <Row style={{ margin: 0 }}>
                    <Col xs>
                        <Row center="xs">
                            <Col xs={10}>
                                <img src={asulogo} style={logoStyle} />
                                <div style={{ textAlign: 'left', marginLeft: leftPosition }}>
                                    <h2 style={{ display: 'inline-block' }}> Arizona State University |</h2>
                                    <h4 style={{ display: 'inline-block' }}> &nbsp;Masters in Computer Science</h4>
                                    <p> Aug 2016 - Expected May 2018</p>
                                    <List>
                                        <h3 style={{fontFamily: "Raleway, sans-serif", marginLeft: 10}}>Courses</h3> 
                                        <ListItem style={listStyle} disabled={true} primaryText="Data Visualization" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="Data Mining" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="Statistical Machine Learning" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="Fundamentals of Stat. Learning" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="Distributed Database System" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="Adaptive Web" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="Software Security" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="Mobile Computing" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="Distributed Multiprocessor Operating System" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                    </List>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Divider style={{ backgroundColor: '#ffd740' }} />
                <Row style={{ margin: 0 }}>
                    <Col xs>
                        <Row center="xs">
                            <Col xs={10}>
                                <img src={pictlogo} style={logoStyle} />
                                <div style={{ textAlign: 'left', marginLeft: leftPosition }}>
                                    <h2 style={{ display: 'inline-block' }}> Pune Institute of Computer Technology |</h2>
                                    <h4 style={{ display: 'inline-block' }}> &nbsp;Computer Engineering</h4>
                                    <p> Aug 2009 - June 2013</p>
                                    <List>
                                        <h3 style={{fontFamily: "Raleway, sans-serif", marginLeft: 10}}>Courses</h3> 
                                        <ListItem style={listStyle} disabled={true} primaryText="Data Structures" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="Design and analysis of Algorithms" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="Operating System" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="Computer Network" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="Relational Database Management System" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="Programming & Problem Solving" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="Computer Graphics" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                        <ListItem style={listStyle} disabled={true} primaryText="Relational Database Management System" leftIcon={<KeyboardArrowRight style={iconStyle} />} />
                                    </List>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Grid>
        );
    }
}

const mapStateToProps = (state) => {
    const { browser, responsiveDrawer } = state;
    return {
        browser,
        responsiveDrawer
    };
};

export default connect(mapStateToProps, null)(Education);


// WEBPACK FOOTER //
// ./src/Education.js